export const ORDER_STATUSES = [
  { id: 'new', name: 'Active' },
  { id: 'dispatched', name: 'Dispatched' },
  { id: 'closed', name: 'Delivered' },
  { id: 'cancelled', name: 'Cancelled' },
];
